// extracted by mini-css-extract-plugin
export default {"primaryButton":"MainButton_primaryButton__5H4D+","primaryButtonDark":"MainButton_primaryButtonDark__BuTKa"};